"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var phocus_1 = require("phocus");
var action_1 = require("../action/action");
var phocus_modal_1 = require("../phocus-modal/phocus-modal");
var command_palette_1 = require("./command-palette");
phocus_1.ActionContextService.addContext("with-command-palette", {
    actions: {
        showPalette: new action_1.Action({
            name: "Command palette",
            defaultKeys: ["Control+Shift+?", "Shift+Meta+P", "Control+Shift+P"],
            actOn: function (component) {
                component.showPalette();
            }
        })
    }
});
var WithCommandPalette = /** @class */ (function (_super) {
    __extends(WithCommandPalette, _super);
    function WithCommandPalette() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            paletteOpen: false
        };
        _this.hidePalette = function () {
            _this.setState({ paletteOpen: false });
        };
        return _this;
    }
    WithCommandPalette.prototype.showPalette = function () {
        this.setState({ paletteOpen: true });
    };
    WithCommandPalette.prototype.componentDidMount = function () {
        phocus_1.ActionContextService.addDefaultContext("with-command-palette", this);
    };
    WithCommandPalette.prototype.componentDidUnMount = function () {
        phocus_1.ActionContextService.removeDefaultContext("with-command-palette", this);
    };
    WithCommandPalette.prototype.render = function () {
        return (React.createElement("div", { className: "phocus-with-command-palette" },
            this.props.children,
            this.state.paletteOpen && (React.createElement(phocus_modal_1.PhocusModal, { close: this.hidePalette },
                React.createElement(command_palette_1.CommandPalette, null)))));
    };
    return WithCommandPalette;
}(React.Component));
exports.WithCommandPalette = WithCommandPalette;
//# sourceMappingURL=with-command-palette.js.map